////////////////////////////////////////////////////////////////////////////////
//
// TTN API module
//
// Unlike the other modules in this folder, this one takes the entity name as an
// explicit parameter on every call. That is deliberate: the entity settings page
// (`/entity/config`) is not necessarily the active entity in the store, so
// relying on `tenantPrefix()` would be fragile. Superadmin flows that manage any
// entity also need explicit control.
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

const path = (entity) => `tenant/${entity}/ttn/integration`;

const ttn = {
    /** Read the current integration for an entity (404 when none exists). */
    get(entity) {
        return ApiService.customRequest({ method: 'get', url: path(entity) });
    },

    /** Create or update. Body: { display_name, base_url, application_id, api_key? } */
    save(entity, data) {
        return ApiService.customRequest({ method: 'put', url: path(entity), data });
    },

    /** Re-run the connection check against TTN. */
    test(entity) {
        return ApiService.customRequest({ method: 'post', url: `${path(entity)}/test` });
    },

    /** Remove the integration. */
    remove(entity) {
        return ApiService.customRequest({ method: 'delete', url: path(entity) });
    },
        /** Provision or re-provision a LoRa device. */
    provisionDevice(entity, name) {
        return ApiService.customRequest({
            method: 'post',
            url: `tenant/${entity}/ttn/devices/${name}/provision`,
        });
    },

    /** Detach a LoRa device from TTN (device record is kept, LoRa fields cleared). */
    detachDevice(entity, name) {
        return ApiService.customRequest({
            method: 'delete',
            url: `tenant/${entity}/ttn/devices/${name}`,
        });
    },
};

export default ttn;